import { cx } from "@suse-o11y/class-variance";
import { IconLockOutlined, IconUnlockOutlined } from "@suse-o11y/icons";
import type { Record } from "@suse-o11y/record";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React from "react";

import { Api, type DashboardScope } from "../../common/openapi";

const DASHBOARD_SCOPE_TO_ICON = {
	[Api.DashboardScope.PublicDashboard]: {
		tooltip: "Public",
		Icon: IconUnlockOutlined,
	},
	[Api.DashboardScope.PrivateDashboard]: {
		tooltip: "Private",
		Icon: IconLockOutlined,
	},
} satisfies Record<DashboardScope>;

export interface DashboardScopeIconProps {
	dashboardScope: undefined | DashboardScope;
	variant?: "light" | "dark";
	className?: string;
}

export const DashboardScopeIcon: React.FC<DashboardScopeIconProps> = ({
	dashboardScope,
	variant = "dark",
	className,
}) => {
	const { tooltip, Icon } = DASHBOARD_SCOPE_TO_ICON[dashboardScope ?? Api.DashboardScope.PrivateDashboard];

	return (
		<TooltipBoundary>
			<TooltipTrigger
				aria-busy={dashboardScope === undefined}
				aria-label={tooltip}
				className={cx("aria-busy:skeleton h-auto", className)}
			>
				<Icon className={variant === "dark" ? "text-grey-600" : "text-grey-500"} height={18} width={18} />
			</TooltipTrigger>

			<Tooltip className="tooltip/tooltip">{tooltip}</Tooltip>
		</TooltipBoundary>
	);
};
